import { Trans, useTranslation } from "react-i18next";

import { ResponsiveTitleBar, LinkButton } from "../../Atoms";
import { StartTabCheckoutSession } from "../Checkout/TablePayPayment";

export const StartBillSplitSession = () => {
  const { t } = useTranslation("onsite");

  return (
    <div className="mx-auto max-w-screen-sm space-y-32">
      <ResponsiveTitleBar>{t("billSplit.settleUp")} </ResponsiveTitleBar>
      <div className="space-y-24">
        <h2 className="text-2xl font-bold">
          {" "}
          {t("billSplit.payForEverything")}
        </h2>
        <StartTabCheckoutSession />
      </div>
      <div className="text-center text-4xl font-semibold uppercase leading-loose">
        {t("billSplit.or")}
      </div>
      <div className="space-y-24">
        <div className="space-y-12">
          <div>
            <h2 className="text-2xl font-bold">
              {" "}
              {t("billSplit.splitTheBill")}
            </h2>
          </div>
          <Trans
            i18nKey="billSplit.ownerBillSplitDescription"
            components={{
              para: <p />,
              strong: <span className="font-bold" />,
              semiStrong: <span className="font-semibold" />,
            }}
          />
        </div>
        <LinkButton primary to="../customer?owner=true">
          {t("billSplit.startSplitting")}
        </LinkButton>
      </div>
    </div>
  );
};
